import styled from '@emotion/styled';
import { Typography } from '@mgmresorts/mgm-ui';

export const StyledContent = styled.div``;

export const StyledHeading = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  padding-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentXl}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;

export const StyledInfo = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentS}px;
`;

export const StyledSubTitle = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentL}px;
`;

export const StyledAddressSubTitle = styled(Typography)`
  color: ${({ theme }) => theme.semantic.FgDefault};
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;

export const StyledInputContainer = styled.div`
  margin-top: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;

export const StyledAlertContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.semantic.SpaceComponentM}px;
`;
